import DropdownController from "./dropdown_controller"

// Dodatkowa opcjonalna logika dla kontrolera animated-dropdown:
// Zmienna query_only jest ustawiana na true podczas połączenia kontrolera
// i przechowuje stan trybu zapytania. Metoda switchQueryMode przełącza ten stan
// i odpowiednio włącza lub wyłącza wszystkie pola formularza oprócz pola "q",
// które są wewnątrz opcjonalnego pola queryExtensionTarget.

// Connects to data-controller="animated-dropdown"
export default class extends DropdownController {
  static targets = ["button", "queryExtension"]

  connect() {
    super.connect()
    this.switchQueryMode(true)
  }

  toggle() {
    this.rotateButton()
    super.toggle()
    this.switchQueryMode()
  }

  rotateButton() {
    if (this.buttonTarget.classList.contains("rotate-0")) {
      this.buttonTarget.classList.remove("rotate-0")
      this.buttonTarget.classList.add(`rotate-${this.degreesValue}`)
    } else {
      this.buttonTarget.classList.remove(`rotate-${this.degreesValue}`)
      this.buttonTarget.classList.add("rotate-0")
    }
  }

  outsideHide(event) {
    console.log("outsideHide1", event)
    console.log("outsideHide2", event.target)

    if (event.target.closest("button[data-action=\"click->intum-select#toggleResult click->intum-select#removeBubble\"]")) {
      return
    }
    // this.hide(event)
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      this.switchQueryMode()
      this.rotateButton()
      this.leave()
      this.removeEvent()
    }
  }

  switchQueryMode(force = null) {
    this.queryOnly = force !== null ? force : !this.queryOnly
    console.log("queryOnly mode:", this.queryOnly)

    if (this.hasQueryExtensionTarget) {
      const inputs = this.queryExtensionTarget.querySelectorAll("input, select, textarea")
      inputs.forEach(input => {
        if (input.name !== "q") {
          input.disabled = this.queryOnly
        }
      })
    }
  }
}
